import type { ThunkDispatch, UnknownAction } from "@reduxjs/toolkit";
import { useDispatch, useSelector, type TypedUseSelectorHook } from "react-redux";
import type { AnalyticsState } from "./analytics.slice";

/**
 * Deliberately local, narrow typing (just this module's own slice) rather
 * than importing the app-wide `RootState`/`AppDispatch` from `@vv/state`
 * - that package composes the real store by importing this module's reducer,
 * so importing back from here would be a circular workspace dependency.
 */
interface AnalyticsModuleState {
  analytics: AnalyticsState;
}

type AnalyticsModuleDispatch = ThunkDispatch<AnalyticsModuleState, unknown, UnknownAction>;

export const useAnalyticsDispatch = () => useDispatch<AnalyticsModuleDispatch>();
export const useAnalyticsSelector: TypedUseSelectorHook<AnalyticsModuleState> = useSelector;
